import {
    DEALERADDORUPDATEDSRLIST_FAILED,
    DEALERADDORUPDATEDSRLIST_SUCCESS,
    RESET_DEALERADDORUPDATEDSRLIST,
    LOADING_DEALERADDORUPDATEDSRLIST,
    NETWORK_ERROR_DEALERADDORUPDATEDSRLIST
} from "../types/index"


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDORUPDATEDSRLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDORUPDATEDSRLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDORUPDATEDSRLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDORUPDATEDSRLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDORUPDATEDSRLIST:
            return (state = initialState);
        default:
            return state;
    }
};